import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Section, SectionHeading } from '../ui/Section';
const steps = [{
  n: 1,
  title: 'Understand the firm',
  body: 'We begin with your people, workflows, applications, priorities and concerns.'
}, {
  n: 2,
  title: 'Review the environment',
  body: 'We map support, security, infrastructure, software, licensing and ownership gaps.'
}, {
  n: 3,
  title: 'Prioritise and plan',
  body: 'You receive practical recommendations, dependencies, timing and decision points.'
}, {
  n: 4,
  title: 'Transition, own and improve',
  body: 'If CT Group is the right fit, changes are planned in stages and responsibilities become clear.'
}];
const reassurance = ['No automatic rip-and-replace', 'No forced provider change', 'Dependencies mapped before action', 'Scope and fees confirmed before work begins'];
export function Process() {
  return <Section id="how" className="bg-white" ariaLabel="Engagement process" data-id="element-396">
      <SectionHeading eyebrow="A clear path, without unnecessary disruption" title="Start with clarity. Change only what needs to change." data-id="element-397" />

      <ol className="relative mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4" data-id="element-398">
        {/* connecting line on desktop */}
        <div className="pointer-events-none absolute left-0 right-0 top-[22px] hidden h-px bg-border lg:block" aria-hidden data-id="element-399" />
        {steps.map((s, i) => <motion.li key={s.n} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className="relative" data-id="element-400">
            <span className="relative z-10 flex h-11 w-11 items-center justify-center rounded-full bg-ct-cyan font-display text-[18px] font-black text-white shadow-cyan ring-4 ring-white" data-id="element-401">
              {s.n}
            </span>
            <div className="mt-5 rounded-card border border-border bg-white p-6 shadow-sm transition-all duration-300 ease-smooth hover:-translate-y-1 hover:shadow-md" data-id="element-402">
              <h3 className="font-display text-[18px] font-bold text-navy" data-id="element-403">
                {s.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-slate" data-id="element-404">
                {s.body}
              </p>
            </div>
          </motion.li>)}
      </ol>

      <div className="mt-10 rounded-card border border-border bg-surface-2 px-6 py-6" data-id="element-405">
        <div className="grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-406">
          {reassurance.map(r => <span key={r} className="flex items-center gap-2.5 text-[14px] font-semibold text-ink" data-id="element-407">
              <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-managed/12" data-id="element-408">
                <Check className="h-3.5 w-3.5 text-managed-deep" aria-hidden data-id="element-409" />
              </span>
              {r}
            </span>)}
        </div>
      </div>
    </Section>;
}